import z from 'zod';

const serviceAccountPinSchema = z.object({
  Type: z.string(),
  Code: z.string(),
});

export const contactSelectionStateSchema = z.object({
  pins: z.array(serviceAccountPinSchema),
});
export type ContactSelectionState = z.infer<typeof contactSelectionStateSchema>;

export const codeInputStateSchema = z.object({
  contactType: z.enum(['Sms', 'Email']),
  targetId: z.string().min(1),
  pins: z.array(serviceAccountPinSchema),
});
export type CodeInputState = z.infer<typeof codeInputStateSchema>;
